import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-bg0 flex items-center justify-center px-6">
      <div className="ep-card p-12 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <XCircle size={44} className="text-epmuted mx-auto" />
        <h1 className="font-display uppercase text-3xl font-bold tracking-tight mt-6">Checkout cancelled.</h1>
        <p className="text-epsub mt-3">No charge was made. Come back when you're ready.</p>
        <Link to="/subscribe" data-testid="retry-subscribe" className="ep-btn inline-block mt-6 bg-volt text-black px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover">
          View membership
        </Link>
      </div>
    </div>
  );
}
